import { render } from "./InchesMilimetersInput.vue?vue&type=template&id=fe5aa850"
import script from "./InchesMilimetersInput.vue?vue&type=script&lang=js"
export * from "./InchesMilimetersInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/denis/Documents/Работа/bitbucket/mifab/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__